import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  NovoAcessoPayload, criarAcessoExterno, listarAcessosExternos, portalDoCliente, reenviarAcessoExterno, situacaoAcessoExterno,
} from '../api/acessosExternos';

const KEY = (clientId: string) => ['clientes', clientId, 'acessos-externos'] as const;

export const useAcessosExternos = (clientId: string, enabled = true) =>
  useQuery({ queryKey: KEY(clientId), queryFn: () => listarAcessosExternos(clientId), enabled });

function useWrite<TArgs, TResult>(clientId: string, fn: (args: TArgs) => Promise<TResult>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY(clientId) });
      qc.invalidateQueries({ queryKey: ['clientes', clientId] });
    },
  });
}

export const useCriarAcessoExterno = (clientId: string) =>
  useWrite(clientId, (p: NovoAcessoPayload) => criarAcessoExterno(clientId, p));
export const useSituacaoAcessoExterno = (clientId: string) =>
  useWrite(clientId, ({ userId, active }: { userId: string; active: boolean }) => situacaoAcessoExterno(clientId, userId, active));
export const useReenviarAcessoExterno = (clientId: string) =>
  useWrite(clientId, (userId: string) => reenviarAcessoExterno(clientId, userId));

export const usePortalDoCliente = () => useQuery({ queryKey: ['portal-cliente', 'me'], queryFn: portalDoCliente });
